import { useTranslation } from 'react-i18next'

import { Plus } from '@phosphor-icons/react'

import { Button, Divider, Pagination } from '@reveni-io/reveni-ui'

import ExceptionItem from '../ExceptionItem/ExceptionItem'
import ExceptionsListSkeleton from '../ExceptionsListSkeleton/ExceptionsListSkeleton'
import * as Styles from './styles'

const ExceptionsContent = ({
  loading,
  exceptions,
  totalPages,
  policyRules,
  currentPage,
  onChangePage,
  onEdit,
  onDelete,
  onToggle,
  onCreateNew,
  hasEditPermission,
}) => {
  const { t } = useTranslation()

  if (loading) {
    return <ExceptionsListSkeleton />
  }

  return (
    <>
      <Styles.ExceptionItemsContainer>
        {exceptions?.results?.map((exception, index) => (
          <ExceptionItem
            exception={exception}
            policyRules={policyRules}
            key={exception.id}
            index={index}
            onEdit={onEdit}
            onDelete={onDelete}
            onToggle={onToggle}
            disabled={!hasEditPermission}
          />
        ))}
      </Styles.ExceptionItemsContainer>

      {exceptions?.count > 0 && (
        <>
          <Divider />
          <Styles.PaginationContainer>
            <Pagination
              count={totalPages}
              page={currentPage}
              onChangePage={onChangePage}
              next={exceptions?.next}
              previous={exceptions?.previous}
            />
          </Styles.PaginationContainer>
        </>
      )}

      <div>
        {hasEditPermission && (
          <Button variant="text" size="s" onClick={onCreateNew}>
            <Plus size={24} />
            {t('Añadir excepción')}
          </Button>
        )}
      </div>
    </>
  )
}

export default ExceptionsContent
